module.exports = __webpack_public_path__ + "img/apple.c6d67773.svg";